<template>
  <div class="padded">

    <h2>Stale Requests</h2>
    <el-alert title="Note:" description="These are request steps with no files uploaded."   show-icon :closable="false" />

    <xolas-table
      title="Stale Requests"
      :url="'/report/requests/stale' + (this.isTelco() ? '/' + this.org().id : '')"
      :show-search="false"
      :fields="fields"
      />
  </div>
</template>


<script>

export default {

  data () {
    return {
      fields: [
        { name: 'actionType', title: 'Action Type' },
        { name: 'fileTitle', title: 'File Title' },
        { name: 'siteName', title: 'Site Name' },
        { name: 'requestor', title: 'Requestor' },
        { name: 'email', title: 'Email' },
        { name: 'phone', title: 'Phone' },
        { name: 'targetDate', title: 'Target Date' },
        { name: 'updated_at', title: 'Last Updated' }
      ]
    }
  }

}

</script>
